import { render, staticRenderFns } from "./RepamentImg.vue?vue&type=template&id=9db5869a&scoped=true&"
import script from "./RepamentImg.vue?vue&type=script&lang=ts&"
export * from "./RepamentImg.vue?vue&type=script&lang=ts&"
import style0 from "./RepamentImg.vue?vue&type=style&index=0&id=9db5869a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db5869a",
  null
  
)

export default component.exports